<template>
  <div>
    <div>
      <div>
        <div class="table-responsive ">
          <table class="table table-borderless">
            <tbody>
              <tr v-for="(value, name, idx) in dataObject" :key="idx">
                <td class="pl-0 font-weight-bold">{{ name || 'N/A' }}</td>
                <td class="pr-0 text-left text-dark">
                  {{ value || 'N/A' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'DataTableLoop',
  props: {
    tableData: {
      type: Object as PropType<any>,
      required: true,
    },
  },
  setup(props) {
    const dataObject = computed(() => props.tableData)
    return {
      dataObject,
      props,
    }
  },
})
</script>

<style lang="scss" scoped>
.table th,
.table td {
  padding: 0.35rem;
}
</style>
